import React, { useState, useRef } from 'react'
import { Button } from "@material-ui/core"
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate'
import CloseIcon from '@material-ui/icons/Close'
import firebase from "firebase"
import { storage, db } from "./firebase"
import './ImageUpload.css'
import Textarea from 'react-expanding-textarea'

function ImageUpload({lang, username, closemodal, viewwhichuser, viewsinglepost}) {
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [progress, setProgress] = useState(0);
    const [caption, setCaption] = useState('');
    const fileInputRef = useRef(null);

    const handleChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setImage(file);
            setPreview(URL.createObjectURL(file));
        }
    }

    const handleRemoveImage = () => {
        setImage(null);
        setPreview(null);
    }

    const handleUpload = () => {
        if (!image) {
            return;
        }

        // This is what uploads the image to Firebase
        const uploadTask = storage.ref(`images/${image.name}`).put(image);
        
        uploadTask.on(
            "state_changed",
            (snapshot) => {
                // progress function
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                setProgress(progress);
            },
            (error) => {
                // Error function
                console.error(error);
                alert(error.message);
            },
            () => {
                // complete function
                storage
                    .ref("images")
                    .child(image.name)
                    .getDownloadURL()
                    .then(url => {
                        // Post image URL inside db
                        db.collection("posts").add({
                            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                            caption: caption,
                            imageUrl: url,
                            username: username,
                            imagename: image.name
                        });

                        // Reset everything once upload process is completed
                        setProgress(0);
                        setCaption("");
                        setImage(null);
                        setPreview(null);
                        closemodal(false);

                        // Scroll back to top and reset other states so that it goes back to default list
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;
                        viewwhichuser('');
                        viewsinglepost(false);
                    })
            }
        )
    }

    return (
        <div className="imageupload">
            <div className="imageupload__header">
                <h3 className="imageupload__title">
                    {lang ? "Créer une publication" : "Create New Post"}
                </h3>
                <button
                    type="button"
                    className="imageupload__closeBtn"
                    onClick={() => closemodal(false)}
                    aria-label="Close"
                >
                    <CloseIcon />
                </button>
            </div>

            {preview ? (
                <div className="imageupload__previewContainer">
                    {image && image.type && image.type.startsWith('video') ? (
                        <video src={preview} className="imageupload__previewMedia" controls />
                    ) : (
                        <img src={preview} alt="Preview" className="imageupload__previewMedia" />
                    )}
                    <div className="imageupload__previewActions">
                        <button
                            type="button"
                            className="imageupload__previewActionBtn"
                            onClick={() => fileInputRef.current && fileInputRef.current.click()}
                        >
                            {lang ? "Changer" : "Change photo"}
                        </button>
                        <button
                            type="button"
                            className="imageupload__previewActionBtn imageupload__previewActionBtn--remove"
                            onClick={handleRemoveImage}
                        >
                            {lang ? "Retirer" : "Remove"}
                        </button>
                    </div>
                </div>
            ) : (
                <div
                    className="imageupload__dropzone"
                    onClick={() => fileInputRef.current && fileInputRef.current.click()}
                >
                    <AddPhotoAlternateIcon className="imageupload__dropzoneIcon" />
                    <span className="imageupload__dropzoneText">
                        {lang ? "Sélectionner une photo ou vidéo" : "Select a photo or video"}
                    </span>
                    <span className="imageupload__dropzoneSubtext">
                        {lang ? "Cliquez ici pour parcourir vos fichiers" : "Click here to browse your files"}
                    </span>
                </div>
            )}

            <input
                ref={fileInputRef}
                type="file"
                accept="image/*,video/*"
                style={{ display: 'none' }}
                onChange={handleChange}
            />

            <Textarea
                className="imageupload__caption"
                type="text"
                value={caption}
                placeholder={lang ? 'Ajoutez une description...' : 'Write a caption...'}
                onChange={event => setCaption(event.target.value)}
            />

            {progress > 0 && (
                <div className="imageupload__progressWrapper">
                    <progress className="imageupload__progress" value={progress} max="100" />
                    <span className="imageupload__progressText">{progress}%</span>
                </div>
            )}

            <Button
                className="imageupload__submitBtn"
                onClick={handleUpload}
                disabled={!image || progress > 0}
            >
                {progress > 0
                    ? (lang ? "Publication en cours..." : "Uploading...")
                    : (lang ? "Publier" : "Share")}
            </Button>
        </div>
    )
}

export default ImageUpload
